export default __webpack_public_path__ + "static/media/header-XC40.40277fd6.jpg";